import { render } from "./icon-service.vue?vue&type=template&id=3d6a335b&ts=true"
import script from "./icon-service.vue?vue&type=script&lang=ts"
export * from "./icon-service.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__